var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
// #F15700
function IconSpeaker(_a) {
    var { fillColor, opacity } = _a, props = __rest(_a, ["fillColor", "opacity"]);
    return (React.createElement("svg", Object.assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { id: "campaign_FILL0_wght400_GRAD0_opsz48 1" },
            React.createElement("path", { id: "Vector", d: "M15.2084 11.0148V9.76481H18.3334V11.0148H15.2084ZM16.2501 17.0565L13.7292 15.1815L14.4792 14.1815L17.0001 16.0565L16.2501 17.0565ZM14.5417 6.57731L13.7917 5.57731L16.2501 3.72314L17.0001 4.72314L14.5417 6.57731ZM4.37508 16.2231V12.8898H2.91675C2.573 12.8898 2.27873 12.7674 2.03394 12.5226C1.78914 12.2778 1.66675 11.9836 1.66675 11.6398V9.13981C1.66675 8.79606 1.78914 8.50179 2.03394 8.257C2.27873 8.01221 2.573 7.88981 2.91675 7.88981H6.66675L10.8334 5.38981V15.3898L6.66675 12.8898H5.62508V16.2231H4.37508ZM11.6667 13.1815V7.59814C12.0417 7.93148 12.3438 8.33773 12.573 8.81689C12.8022 9.29606 12.9167 9.82037 12.9167 10.3898C12.9167 10.9593 12.8022 11.4836 12.573 11.9627C12.3438 12.4419 12.0417 12.8481 11.6667 13.1815ZM2.91675 9.13981V11.6398H7.00008L9.58341 13.1815V7.59814L7.00008 9.13981H2.91675Z", fill: fillColor, fillOpacity: opacity }))));
}
export default memo(withIconDefaults(IconSpeaker));
